import React from "react";
import * as Yup from "yup";
import { Formik, Form } from "formik";
import {
    TextField,
    Button,
    Typography,
    Link,
    DialogActions,
    CircularProgress
} from "@mui/material";

const ForgotPasswordSchema = Yup.object().shape({
    email: Yup.string()
        .email("Invalid email")
        .required("You must enter your email"),
});


const ForgotPasswordForm = ({ isEmailSending, onSubmit, onClose, onRegister }) => (
    <Formik
        initialValues={{ email: "" }}
        validationSchema={ForgotPasswordSchema}
        onSubmit={onSubmit}
    >
        {({ values, errors, touched, handleChange, handleBlur }) => (
            <Form>
                {/* Email */}
                <TextField
                    // autoFocus
                    margin="dense"
                    id="email"
                    name="email"
                    label="Email Address"
                    type="email"
                    fullWidth
                    value={values.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.email && Boolean(errors.email)}
                    helperText={touched.email && errors.email}
                    disabled={isEmailSending}
                />

                <Typography variant="body2" sx={{ mt: 2 }}>
                    {isEmailSending ? (
                        <span style={{ color: "gray", cursor: "default" }}>Email being sent...</span>
                    ) : (
                        <Link color="primary.dark" style={{ cursor: "pointer" }} onClick={onRegister}>Don't have an account? Register</Link>
                    )}
                </Typography>

                <DialogActions>
                    <Button
                        type="submit"
                        sx={{
                            color: "primary.dark"
                        }}
                        disabled={isEmailSending}
                        startIcon={isEmailSending ? <CircularProgress size={24} /> : null}
                    >
                        {isEmailSending ? "Sending..." : "Send Mail"}
                    </Button>

                    <Button
                        onClick={onClose}
                        sx={{
                            color: "warning.dark"
                        }}
                        disabled={isEmailSending}
                    >Cancel</Button>
                </DialogActions>
            </Form>
        )}
    </Formik>
);

export default ForgotPasswordForm;